import { OAuth2Service } from './OAuth2Service';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { CommonModule } from '@angular/common';

@NgModule({
	imports: [
		CommonModule,
		HttpClientModule,
	],
	providers: [
		OAuth2Service,
	],
	declarations: []
})
export class RestModule { }



// WEBPACK FOOTER //
// ./src/app/angular-rest/rest.module.ts